/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._00uqCY98eZ%7Btext-decoration-color%3AcurrentColor%7D%0A._3xtjKNYbGa%7Btext-decoration-line%3Anone%7D%0A._0H9qDF6wH8%7Btext-decoration-style%3Asolid%7D%0A._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._0clgaMZpcK%3Ahover%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0A._3932vv0Rl6%3Ahover%7Btext-decoration-line%3Aunderline%7D%0A._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0A._0clgaMe5R3%3Ahover%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._1bHrqEdnbC%7Bflex-basis%3A0%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._39xV02xpxF%7Bwidth%3A9pt%7D%0A._0jFU0VxpxF%7Bheight%3A9pt%7D%0A._00EA0eiObl%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
























import React, { useRef } from 'react';
import { cx } from '@atlaskit/css';
import FileIcon from '@atlaskit/icon/core/file';
import ImageIcon from '@atlaskit/icon/core/image';
import LinkIcon from '@atlaskit/icon/core/link';
import PageIcon from '@atlaskit/icon/core/page';
import PagesIcon from '@atlaskit/icon/core/pages';
import StoryIcon from '@atlaskit/icon/core/story';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import type { Conversation } from '../../../types';
const styles = {
  scopeLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _0clgaMZpcK",
  scopeLinkDefault: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1EqgXlN91d _4ouGXIdnbC",
  scopeRowDefault: "_39xV02N91d _1EqgXlN91d _4ouGXIdnbC",
  scopeLinkTooltip: "_4bt5LAnQyn _2WAcuGnQyn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbvLZJ _39xV02N91d _4ouGXIdnbC _1UtDYze5R3 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMe5R3",
  scopeRowTooltip: "_39xV02N91d _4ouGXIdnbC",
  scopeNameTooltip: "_1UtDYze5R3 _3iDTPbvLZJ _1bHrqEdnbC _2O5Vij7dHp _4ouGXIdnbC",
  scopeNameTooltipSingleLine: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1bHrqEdnbC _2O5Vij7dHp _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7 _1UtDYze5R3",
  scopeNameDefault: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1bHrqEdnbC _2O5Vij7dHp _4ouGXIdnbC _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7",
  scopeLinkIconImage: "_0bjKvDKxmn _39xV02xpxF _0jFU0VxpxF _00EA0eiObl _3YEZNOdnbC _3iDTPbvLZJ"
};
export type ScopeRowVariant = 'default' | 'tooltip';
type ConversationScope = NonNullable<Conversation['scopes']>[number];
type ScopeRowScope = Omit<ConversationScope, 'link'> & {
  link: ConversationScope['link'] | undefined;
};
function getScopeIconComponent(scope: ScopeRowScope, showLinkFallbackIcon: boolean): typeof PageIcon | null {
  switch (scope.type) {
    case 'image':
      return ImageIcon;
    case 'file':
      return FileIcon;
    case 'jira':
      return StoryIcon;
    case 'confluence':
      switch (scope.sub_type) {
        case 'space':
          return PagesIcon;
        case 'whiteboard':
          return WhiteboardIcon;
        case 'page':
        default:
          return PageIcon;
      }
    case 'link':
      return showLinkFallbackIcon ? LinkIcon : null;
    default:
      return null;
  }
}
export type ScopeRowProps = {
  scope: ScopeRowScope;
  variant: ScopeRowVariant;
  maxLines: number;
  /** Whether to render the scope title beside its icon. Defaults to true. */
  showName?: boolean;
  /** Whether links without a remote icon use the generic link icon. Defaults to true. */
  showLinkFallbackIcon?: boolean;
  /** Whether to render the icon when the scope is not linked. Defaults to false. */
  showIconWithoutLink?: boolean;
  onFilePreview?: (link: string, name: string) => void;
  onScopeLinkClick?: (variant: ScopeRowVariant) => void;
  onScopeLinkHover?: () => void;
};

/**
 * Renders a single scope as an icon + name wrapped in an anchor.
 * Used in both the first-scope footer and in the tooltip scope list.
 *
 * Shared between `ChatItem` (conversation-assistant-ui-components) and
 * `ChatListItem` (rovo-navigation).
 */
export const ScopeRow = ({
  scope,
  variant,
  maxLines,
  showName = true,
  showLinkFallbackIcon = true,
  showIconWithoutLink = false,
  onFilePreview,
  onScopeLinkClick,
  onScopeLinkHover
}: ScopeRowProps): JSX.Element => {
  const textColor = variant === 'tooltip' ? 'color.text.inverse' : 'color.text.subtlest';
  const iconColor = variant === 'tooltip' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
  const isFile = scope.type === 'file' || scope.type === 'image';
  const canUseIconUrl = scope.type === 'link' || scope.type === 'jira';
  const ScopeIcon = getScopeIconComponent(scope, showLinkFallbackIcon);
  const hasRemoteScopeIcon = canUseIconUrl && typeof scope.icon_url === 'string' && scope.icon_url.trim().length > 0;

  // Prefer a remote `icon_url` (links / jira) when present; otherwise fall back to the built-in icon.
  const icon = hasRemoteScopeIcon ? <Box as="img" src={scope.icon_url} alt={showName ? '' : scope.name} xcss={styles.scopeLinkIconImage} /> : ScopeIcon ? <ScopeIcon label={showName ? '' : scope.name} size="small" color={iconColor} /> : null;

  // Defensively resolve `link` to a string — the API may return an object or
  // null/undefined for freshly-pasted links before backend normalisation.
  const rawLink = (scope.link as unknown);
  const resolvedLink = typeof rawLink === 'string' ? rawLink : rawLink !== null && typeof rawLink === 'object' ? String((rawLink as Record<string, unknown>).url ?? (rawLink as Record<string, unknown>).href ?? '') : '';

  // Guard: fire the hover analytics event only once per mouseenter/mouseleave
  // cycle, regardless of how many synthetic mouseenter events the browser emits.
  const hasHoveredRef = useRef(false);
  const handleMouseEnter = () => {
    if (!hasHoveredRef.current) {
      hasHoveredRef.current = true;
      onScopeLinkHover?.();
    }
  };
  const handleMouseLeave = () => {
    hasHoveredRef.current = false;
  };
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onScopeLinkClick?.(variant);
    if (isFile && onFilePreview) {
      e.preventDefault();
      onFilePreview(resolvedLink, scope.name);
    }
  };
  const scopeName = showName ? <Box as="span" xcss={variant === 'tooltip' ? maxLines === 1 ? styles.scopeNameTooltipSingleLine : styles.scopeNameTooltip : styles.scopeNameDefault}>
			<Text size="small" weight="regular" maxLines={variant === 'tooltip' && maxLines === 1 ? undefined : maxLines} align="start" color={textColor}>
				{scope.name}
			</Text>
		</Box> : null;
  if (!resolvedLink) {
    return <Inline alignBlock="center" space="space.050" xcss={variant === 'tooltip' ? styles.scopeRowTooltip : styles.scopeRowDefault}>
				{showIconWithoutLink && icon}
				{scopeName}
			</Inline>;
  }
  return <Inline alignBlock="center" space="space.050" xcss={variant === 'tooltip' ? styles.scopeRowTooltip : styles.scopeRowDefault}>
			<Anchor href={resolvedLink} aria-label={showName ? undefined : scope.name} {...isFile ? {} : {
      target: '_blank',
      rel: 'noreferrer'
    }} xcss={cx(styles.scopeLink, variant === 'tooltip' ? styles.scopeLinkTooltip : styles.scopeLinkDefault)} onClick={handleClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
				<Inline alignBlock="center" space="space.050" xcss={variant === 'tooltip' ? styles.scopeRowTooltip : styles.scopeRowDefault}>
					{icon}
					{scopeName}
				</Inline>
			</Anchor>
		</Inline>;
};